module.exports = __webpack_public_path__ + "static/media/YM42_0.011639be.jpg";